export default __webpack_public_path__ + "static/media/bdswissReal02_downloadMT4.8b26b6df.png";